/** @type {import('../schema').ProcessDefinition} */
const novedades = {
  id: "novedades",
  name: "Novedades / anuncios",
  category: "comunicaciones",
  outcome:
    "Comunicar a los residentes de forma estructurada y trazable, opcional con redacción asistida por IA.",
  trigger: "El Administrador escribe un aviso o usa el generador IA.",
  actors: ["Administrador", "Bot Habi", "Residente"],
  status: "COMPLETO",
  description:
    "El admin redacta el aviso (manual o con IA según tema, sector y urgencia), itera el borrador, el sistema lo publica y notifica por los canales disponibles y queda archivado en el histórico.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "bot", actor: "Bot Habi" },
    { id: "res", actor: "Residente" },
  ],
  steps: [
    { id: "s1", laneId: "admin", type: "start", label: "Inicia la redacción del aviso", description: "Define tema, sector y urgencia.", evidence: "src/screens/admin/NovedadesEdificio.jsx" },
    { id: "s2", laneId: "admin", type: "decision", label: "¿Manual o con IA?" },
    { id: "s3", laneId: "bot", type: "task", label: "Genera/mejora el copy", description: "Produce el texto en email / WhatsApp / in-app según tema, sector y urgencia.", evidence: "src/utils/communicationTemplates.js" },
    { id: "s4", laneId: "admin", type: "task", label: "Ajusta el borrador", description: "Itera el texto antes de publicar." },
    { id: "s5", laneId: "admin", type: "decision", label: "¿A todos o a un sector?" },
    { id: "s6", laneId: "admin", type: "notification", label: "Publica y notifica", description: "El sistema publica y notifica por los canales disponibles (email/WhatsApp/in-app).", evidence: "src/screens/admin/NovedadesEdificio.jsx" },
    { id: "s7", laneId: "res", type: "task", label: "Recibe la novedad" },
    { id: "s8", laneId: "admin", type: "end", label: "Queda archivada en el histórico", description: "La novedad pasa a archivada.", evidence: "src/screens/admin/NovedadesEdificio.jsx" },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3", label: "IA" },
    { from: "s2", to: "s4", label: "manual" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6", label: "todos / sector" },
    { from: "s6", to: "s7" },
    { from: "s7", to: "s8" },
  ],
};

export default novedades;
